import template from './shippingMethodForm.html';
import './shippingMethodForm.scss';

export const ShippingMethodForm = angular
    .module('checkout.components.shippingMethodForm', [])
    .component('shippingMethodForm', {
        template,
        bindings: {
            shippingMethods: '<',
            selectedMethodIndex: '=',
            disableForm: '<'
        },
        controller: class ShippingMethodFormController {
            $onInit() {
                const shippingMethods = this.shippingMethods || [];
                shippingMethods.forEach((method) => {
                    method.deliveryEstimate = (method.deliveryEstimate || '').trim();
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/shippingMethodForm/shippingMethodForm.js